import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountRecord } from '@tassat/fred-definitions';
import { WalletRecordMapped } from '@tassat/fred-extended-definitions';
import React from 'react';

interface PrimaryWalletCellRendererProps {
    value: { Account: string } | string;
    data: AccountRecord;
    nestedEntity?: string;
    context: { wallets: Array<WalletRecordMapped> };
}

const muiStyles = makeStyles({
    root: {
        whiteSpace: 'normal' as const,
        height: '100%'
    },
    primarySymbol: {
        color: '#202020',
        background: '#EDCB26',
        border: '1px solid #CFCFCF'
    },
    name: {
        lineHeight: '20px',
        wordBreak: 'break-word' as const
    }
});

const primaryWalletCellRenderer = (props: PrimaryWalletCellRendererProps) => {
    const {
        data,
        context
    } = props;

    const { wallets } = context;

    const classes = muiStyles(props);
    const primaryWallet = wallets
        .find(({ wallet }) => wallet?.LinkedAccount?.AccountId === data.AccountId && wallet.IsPrimary);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {primaryWallet ?
                (
                    <span className={classes.name}>{primaryWallet.wallet.AccountName}</span>
                )
                : <span />}
        </Grid>
    );
};

export default primaryWalletCellRenderer;